import { AppRoute } from '../../enums';
import { AuthenticationFacade } from '../auth';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const goToDashboardIfLoggedIn: CanActivateFn = async () => {
  const authenticationFacade = inject(AuthenticationFacade);
  const router = inject(Router);
  const isAuthenticated: boolean = await authenticationFacade.isAuthenticated();
  return isAuthenticated ? router.parseUrl(`/${AppRoute.DashboardPage}`) : true;
};
